// SmartFeedSeeAllDestination.js
import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import SmartFeedPagination from "%/dynamic-component-editor/options/smart-feed-pagination";
import { titleToKebabCase } from "@bloglovin/vue-framework";

// Lazy store resolution: a module-scope import here closes a cycle
// (stores -> components -> mixins -> classes). See scripts/find-import-cycles.py.
// eslint-disable-next-line global-require
const useConfigurationPanelStore = (...args) => require("%/dynamic-component-editor/stores/configuration-panel-store").useConfigurationPanelStore(...args);
// eslint-disable-next-line global-require
const useGeneralStore = (...args) => require("%/dynamic-component-editor/stores/general-store").useGeneralStore(...args);
// eslint-disable-next-line global-require
const useFanPublicationStore = (...args) => require("%/dynamic-component-editor/stores/fan-publication-store").default(...args);


export default class SmartFeedSeeAllDestination extends BaseOption {
  static label = "See All Destination Page";
  static userInterfaceComponent = {
    component: inspectorTools.AUTOCOMPLETE,
    props: {
      isAsync: true,
      showAllResultsOnClick: true,
      sourceUrl: () => {
        return useGeneralStore().apiV1 + `/publication/${useFanPublicationStore().publicationId}/pages/autocomplete`;
      },
      itemValueKey: "value",
      itemLabelKey: "label",
      canCreateNewItem: true,
      customItemLabel: "Create new page",
      placeholder: "Search pages...",
      runInitialSearch: true,
      includeValueType: "string",
      onCreateItem: (data, context) => {
        const pageName = data.query;
        const pageSlug = titleToKebabCase(pageName);

        useConfigurationPanelStore().createDynamicPage({
          name: pageName,
          slug: pageSlug,
          template: 0,
        }, () => {
          context.setValue({
            value: pageSlug,
            label: pageName,
          });
        });
      },
    },
  };
  static defaultValue = "";
  static canShow(paginationType) {
    return paginationType.id === SmartFeedPagination.optionValues.linkToViewAllPage.id;
  }
}
